
import { ManagedStockSearchFilterQuery } from "../models/filters/managedStocks/ManagedStockSearchFilterQuery";
import { ProductsSearchFilterQuery } from "../models/filters/products/ProductsSearchFilterQuery";
import { useAppSelector } from "../redux/hooks";
import { RootState } from "../redux/store";

export function useStockFilter(){
    const { 
        keyword, 
        departmentIdFilter, 
        subdepartmentIdFilter,
        supplierIdFilter,
        stockGroupIdFilter,
        activeFilter,
        ethicalFilter,
        scheduleFilter,
        pbsFilter,
        searchPdes,
        searchBarcodes,
    } = useAppSelector((state: RootState) => state.stocks);
    function getStockFilterOptions(): ManagedStockSearchFilterQuery {
		const payload: ManagedStockSearchFilterQuery = {
            ...(keyword && { contains: true }),
            ...(keyword && { keyword: keyword }),
            ...(searchPdes && { searchPdes: searchPdes }),
            ...(searchBarcodes && { searchBarcodes: searchBarcodes }),
            ids: [],
            excludedIds: [],
            ...(departmentIdFilter !== null ? { departmentIds: [departmentIdFilter] } : { departmentIds: [] }),
            ...(subdepartmentIdFilter !== null ? { subdepartmentIds: [subdepartmentIdFilter] } : { subdepartmentIds: [] }),
            ...(supplierIdFilter !== null ? { supplierIds: [supplierIdFilter] } : { supplierIds: [] }),
            ...(stockGroupIdFilter !== null ? { stockGroupIds: [stockGroupIdFilter] } : { stockGroupIds: [] }),
            ...(activeFilter !== null ? { active: activeFilter } : { active: null }),
            ...(ethicalFilter !== null ? { ethical: ethicalFilter === true ? true : false } : { ethical: null }),
            ...(scheduleFilter !== "" ? { schedule: scheduleFilter } : { schedule: "" }),
            ...(pbsFilter !== null ? { pbs: pbsFilter === true ? true : false } : { pbs: null }),
            linkedToSystem: null,
            productIds: [],
            loadDetails: [],
            offset: null,
            limit: null,

        };
		return payload;
	}
    return getStockFilterOptions;
}

export function useProductFilter(){
    const { 
        keyword, 
        supplierCodesFilter,
        ethicalFilter,
        scheduleFilter,
        pbsFilter,
        createDateBeforeFilter,
        createDateAfterFilter,
    } = useAppSelector((state: RootState) => state.products);
    function getProductFilterOptions(): ProductsSearchFilterQuery {
        const payload: ProductsSearchFilterQuery = {
            ...(keyword && { contains: true }),
            ...(keyword && { keyword: keyword }),
            ids: [],
            excludedIds: [],
            ...(ethicalFilter !== 0 && { ethical: ethicalFilter === 1 ? true : false }),
            ...(scheduleFilter !== "0" && { schedule: scheduleFilter }),
            ...(pbsFilter !== 0 && { pbs: pbsFilter === 1 ? true : false }),
            ...(supplierCodesFilter && { supplierCodes: [supplierCodesFilter] }),
            ...(createDateBeforeFilter && { toCreatedDate: createDateBeforeFilter }),
            ...(createDateAfterFilter && { fromCreatedDate: createDateAfterFilter }),
        };
        return payload;
    }
    return getProductFilterOptions;
}